/* eslint-disable import/named */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';
import {
  IconButton,
  Typography,
  Paper,
  Tooltip,
  CircularProgress,
} from '@material-ui/core';
import {
  CloudDownload,
  Delete,
} from '@material-ui/icons';
import MaterialTable from 'material-table';
// import logo from '../../../../shared/img/empty2.png';
import { FormatDateWithTime, FileConvertSize } from '../../../../helpers/utils';
import googleStorageServices from '../../../../redux/services/googleStorageServices';
import { toastError, toastSuccess } from '../../../../redux/actions/alertActions';

const FilesList = ({
  company, group, getFilesFromStorage, filesList,
}) => {
  const [loading, setLoading] = useState(true);

  const handleDownload = async (filename) => {
    const downloadedFile = await googleStorageServices.downloadFile(filename);
    const buffer = Buffer.from(downloadedFile.data[0]);
    const blob = new Blob([buffer]);

    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    document.body.appendChild(a);
    a.style = 'display: none';
    a.href = url;
    a.download = filename.replace(`documents_clients/zoom_link/${company.name}/${group.name}/`, '');
    a.click();
    window.URL.revokeObjectURL(url);
    a.remove();
  };

  const handleDelete = async (filename) => {
    const deletedFile = await googleStorageServices.deleteFile(filename);
    if (deletedFile.status === 200) {
      toastSuccess('File deleted successfully');
      getFilesFromStorage();
    } else {
      toastError('File delete failed');
    }
  };

  useEffect(() => {
    getFilesFromStorage();
    setLoading(false);
  }, []);
  return (
    <>
      {loading === false
        ? (
          <MaterialTable
            title="File list"
            data={filesList}
            columns={[
              {
                title: 'File',
                field: 'name',
                render: ({ name }) => (
                  <Typography variant="body2">
                    {name.replace(`documents_clients/zoom_link/${company.name}/${group.name}/`, '')}
                  </Typography>
                ),
              },
              {
                title: 'Created at',
                field: 'metaData.timeCreated',
                render: (rowData) => (
                  <Typography variant="body2">
                    {FormatDateWithTime(rowData.metadata.timeCreated)}
                  </Typography>
                ),
              },
              {
                title: 'Updated at',
                field: 'metaData.updated',
                render: (rowData) => (
                  <Typography variant="body2">
                    {FormatDateWithTime(rowData.metadata.updated)}
                  </Typography>
                ),
              },
              {
                title: 'File size',
                field: 'metaData.size',
                render: (rowData) => (
                  <Typography variant="body2">
                    {FileConvertSize(rowData.metadata.size)}
                  </Typography>
                ),
              },
              {
                title: 'Download',
                field: 'name',
                render: (rowData) => (
                  <Tooltip title="Télécharger le fichier" placement="bottom">
                    <IconButton onClick={() => handleDownload(rowData.name)}>
                      <CloudDownload style={{ fill: '#2687DC' }} />
                    </IconButton>
                  </Tooltip>
                ),
              },
            ]}
            actions={[
              {
                icon: () => <Delete style={{ fill: '#CE2525' }} />,
                tooltip: 'Delete file',
                onClick: (event, rowData) => handleDelete(rowData.name),
              },
            ]}
            components={{
              // eslint-disable-next-line react/jsx-props-no-spreading
              Container: (containerProps) => (<Paper {...containerProps} elevation={0} />),
            }}
            style={{
              width: '100%',
              color: '#525252',
              boxShadow: 'none',
              marginTop: '30px',
            }}
          />
        )
        : <CircularProgress />}
    </>
  );
};

export default FilesList;
